import axios from "axios";
import { getPlatformSync } from "../hooks/usePlatform";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Resolve a possibly-relative avatar/image URL.
 * - Absolute URLs (http://, https://, data:) are returned as-is.
 * - URLs starting with "/" (e.g. "/api/static/avatars/foo.png") are prefixed
 *   with the backend origin so the browser hits the backend pod via ingress.
 */
export function resolveAssetUrl(url) {
  if (!url) return url;
  if (/^(https?:|data:)/i.test(url)) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
}

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Tell the backend which shell the request came from. Used for
// analytics (native-app vs web attribution) and for the iOS "Reader"
// mode gating on payment endpoints.
api.interceptors.request.use((config) => {
  const p = getPlatformSync();
  config.headers = config.headers || {};
  config.headers["X-Client-Platform"] = p.platform; // "web" | "ios" | "android"
  return config;
});

export default api;
